@let entityId = entityId$ | async;

<div
    [id]="entity().id"
    [attr.data-raw-id]="entity().id"
    class="tab-entity"
    [class.active]="entityId === entity().id"
    [style.--tab-header-bg]="tabHeaderBg()"
    [style.--tab-header-active-bg]="tabHeaderActiveBg()"
    [style.--tab-header-text]="tabHeaderText()"
    [style.--tab-header-active-text]="tabHeaderActiveText()"
    [style.--tab-header-active-border]="tabHeaderActiveBorder()"
    [style.--tab-header-width]="tabHeaderWidth()"
    [style.--tab-header-font-size]="tabHeaderFontSize()"
    [style.--tab-header-font-weight]="tabHeaderFontWeight()"
    [style.--tab-header-font-style]="tabHeaderFontStyle()"
    [style.--tab-header-font-family]="tabHeaderFontFamily()"
    [style.--tab-header-text-transform]="tabHeaderTextTransform()"
    [style.--tab-header-padding]="tabHeaderPadding()"
    [style.--tab-header-radius]="tabHeaderRadius()"
    [style.--tab-header-radius-mobile]="tabHeaderRadiusMobile()"
    [style.--tab-separator-color]="tabSeparatorColor()"
    [style.--tab-separator-border]="tabSeparatorBorder()"
    [style.--tab-active-border-top]="tabActiveBorders().top"
    [style.--tab-active-border-right]="tabActiveBorders().right"
    [style.--tab-active-border-bottom]="tabActiveBorders().bottom"
    [style.--tab-active-border-left]="tabActiveBorders().left"
    [style.--tab-body-bg]="tabBodyBg()"
    [style.--tab-body-padding]="tabBodyPadding()"
    [style.--tab-body-radius]="tabBodyRadius()"
>
    <div
        class="tab-root"
        [id]="rootElementId()"
        [class.tab-left]="form.placement().value() === 'left'"
        [class.tab-right]="form.placement().value() === 'right'"
        [class.tab-top]="form.placement().value() === 'top'"
    >
        <div class="tab-header" [id]="headerElementId()">
            @for (tab of form.tabs().value(); let i = $index; track i) {
                <button
                    type="button"
                    class="tab-header-item click-outside-close-prevent"
                    [class.active]="i === activeIndex()"
                    (click)="setActive(i)"
                >
                    {{ tab?.title || "Tab " + (i + 1) }}

                    @if (isTabContentEmpty(tab.contentEntityId) && !tab.isActive) {
                        <span class="sp-icon icon-warning"></span>
                    }
                </button>
            }

            @if (form.placement().value() === "left" || form.placement().value() === "right") {
                <web-tab-header-width
                    [widthValue]="form.headerWidthValue().value()"
                    [widthUnit]="form.headerWidthUnit().value()"
                    [rootElementId]="rootElementId()"
                    [headerElementId]="headerElementId()"
                    [bodyElementId]="bodyElementId()"
                    [isRight]="form.placement().value() === 'right'"
                    (widthChange)="handleHeaderWidthChange($event)"
                    (dragStart)="handleHeaderWidthDragStart()"
                    (dragEnd)="handleHeaderWidthDragEnd()"
                />
            }
        </div>

        <div class="tab-body" [id]="bodyElementId()" #animatedElem>
            @if (activeChild(); as child) {
                <web-grid [grid]="child" [hideControls]="true" />
            }
        </div>
    </div>

    @if (hideControls$ | async) {
        <web-tab-controls class="tab-entity-controls" (selectEvent)="selectEntity()" (deleteEvent)="deleteEntity()" />
    }
</div>
